import { Navigate, useLocation } from 'react-router-dom'
import { useSession } from '../contexts/SessionContext'
import { UserRole } from '@prescreen/lib/types/user'

interface PrivateRouteProps {
  children: React.ReactNode
  roles?: UserRole[]
}

export default function PrivateRoute({ children, roles }: PrivateRouteProps) {
  const { user, loading } = useSession()
  const location = useLocation()

  if (loading) {
    return <div>Loading...</div>
  }

  if (!user) {
    return <Navigate to={`/login?callbackUrl=${encodeURIComponent(location.pathname)}`} replace />
  }

  if (roles && !roles.includes(user.role as UserRole)) {
    return <Navigate to="/login?error=AccessDenied" replace />
  }

  return <>{children}</>
}

